var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagination"},_vm._l((_vm.indices),function(index){return _c('span',{key:index,staticClass:"pagination__dot",class:{ 'bg-primary border-primary': index === _vm.current, 'border-medium': index !== _vm.current }})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }